import React from "react";
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import {
  setPerformanceCreateAction,
  setPerformanceUpdateAction,
} from "../../../Redux/Slice";
import "../../../StyleSheet/MainComponent/Performance/Performance.scss";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import Select from "react-select";
import Swal from "sweetalert2";

function PerformancePopup(props) {
  const {
    show,
    setShow,
    editPayload,
    refresh,
    selectedPerformanceId,
    setEditPayload,
    EMpHeader,
    search, 
  } = props;
  const [grading_name, setGrading_name] = useState("");
  const [total_points, setTotal_points] = useState("");
  const [points, setpoints] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const dispatch = useDispatch();
  console.log(EMpHeader, "EMpHeaderSelected" , search);
  ///---filter for Skill Ha--------
  const Swal = require("sweetalert2");
  const [typeOfParent, setEmplyeRole] = useState([
    {
      value: "Tech",
      label: "TECHNICAL",
    },
    {
      value: "soft",
      label: "SOFT SERVICES",
    },
  ]);

  const [EMpROleSelected, setEmpRoleSele] = useState([EMpHeader]);

  const [typeOfperformance, setPerformances] = useState(EMpHeader.value);

  const HandleEMprole = (e) => {
    if (e != null) {
      setPerformances(e.value);
      setEmpRoleSele(e);
    }
  };

  const handleSubmit = () => {
    if (Object.keys(editPayload).length > 0) {
      const payload = {
        data: {
          grading_name: grading_name,
          total_points: total_points,
          points: points,
          parent_type: typeOfperformance,
        },
        id: editPayload.id,
        search:search,
        parent_:EMpHeader.value
      };
      dispatch(setPerformanceUpdateAction(payload));
    } else {
      const payload = {
        data:{
          grading_name: grading_name,
        total_points: total_points,
        points: points,
        parent_type: typeOfperformance,
        },
        search:search,
        parent_:EMpHeader.value


      };
      dispatch(setPerformanceCreateAction(payload));
    }
    setEditPayload("");
    setGrading_name("");
    setTotal_points("");
    setShow(false);
  };
  useEffect(() => {
    if (Object.keys(editPayload).length > 0) {
      setEditMode(true);
      setGrading_name(editPayload.grading_name);
      setTotal_points(editPayload.total_points);
      setpoints(editPayload.points);
      setPerformances(editPayload.parent_type);
      if (editPayload.parent_type == "Tech") {
        setEmpRoleSele(typeOfParent[0]);
      } else if (editPayload.parent_type != "Tech") {
        setEmpRoleSele(typeOfParent[1]);
      }
    }
  }, [editPayload]);
  const handleClose = () => {
        const hasdata = Object.keys(editPayload).length > 0 ?  true : grading_name != ""  || total_points != "";
  if(hasdata ){

    Swal.fire({
      title: `Do you want to exit Criteria ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        setEditPayload("");
        setGrading_name("");
        setTotal_points("");
        setShow(false);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  }
  else {
        setEditPayload("");
        setGrading_name("");
        setTotal_points("");
        setShow(false);
  }
  };
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={handleClose}
      className="modelman"
    >
      <Modal.Header className="popHead">
        <Modal.Title>
          {Object.entries(editPayload).length > 0 ? "Criteria" : "Criteria"}
        </Modal.Title>
        <div className="CloseIcon" onClick={handleClose}>
          <CloseOutlinedIcon />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label htmlFor="grading_name">
            Grading Name<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="grading_name"
            onChange={(e) => {
              setGrading_name(e.target.value);
              setIsDirty(true);
            }}
            value={grading_name}
          />
          <label htmlFor="total_points" className="mt-4">
            Total Points<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="number"
            className="form-control"
            id="total_points"
            onChange={(e) => {
              setTotal_points(e.target.value);
              if (e.target.value == "") {
                setIsDirty(false);
              } else if (e.target.value != "") {
                setIsDirty(true);
              }
            }}
            value={total_points}
          />

          <label htmlFor="points" className="mt-4">
            Type of Header<span style={{ color: "red" }}>*</span>
          </label>

          <Select
            className="Selects"
            styles={{ position: "relative", top: "60px" }}
            onChange={(e) => {
              setIsDirty(true);

              HandleEMprole(e);
            }}
            value={EMpROleSelected}
            options={typeOfParent}
            placeholder="search"
          />

          <label htmlFor="points" className="mt-4">
            Points<span style={{ color: "red" }}>*</span>
          </label>

          <input
            type="number"
            className="form-control"
            id="points"
            onChange={(e) => {
              setpoints(e.target.value);
              // setIsDirty(true);
              if (e.target.value == "") {
                setIsDirty(false);
              } else if (e.target.value != "") {
                setIsDirty(true);
              }
            }}
            value={points}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="RoleButton">
          <button
            class="btn  SaveBtn"
            type="submit"
            onClick={(e) => {
              handleSubmit();
            }}
            disabled={
              grading_name.length > 0 && total_points.length > 0 &&  points > 0 && isDirty
                ? false
                : true
            }
          >
            {Object.entries(editPayload).length > 0 ? "Update " : "Create "}
          </button>

          <button class="btn CancelBtn" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default PerformancePopup;
